export default __webpack_public_path__ + "static/media/qr_05.ce162a95.jpg";